module.exports = __webpack_public_path__ + "media/student_contributors/typewriter-57059b0c.png";